import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { KeyboardDoubleArrowRight } from "@mui/icons-material";
import {
  Container,
  Box,
  useTheme,
  Typography,
  Button,
  Grid,
  useMediaQuery,
  Pagination,
  Stack,
  TextField,
  IconButton,
  darken,
  Divider,
  InputAdornment,
  FormControl,
  Select,
  MenuItem,
  Drawer
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { openModal, closeModal } from "../features/slices/modalSlice";
import CopiedTooltip from "../components/common/CopiedTooltip";

import { Close, ArrowBack, CopyAll, ChevronLeft, ChevronRight } from "@mui/icons-material";
import SearchIcon from '@mui/icons-material/Search';

import { selectCurrentToken } from "../features/slices/authSlice";

import {
  useGetGameProviderQuery,
  useLazyGetGameItemQuery,
  useLazyGetLaunchGameQuery,
  useGetGameCategoryQuery,
} from "../features/api/gameApiSlice";
import { useGetHomePageQuery } from "../features/api/homeApiSlice";

import GameCard from "../components/Game/GameCardV2";
import Backdrop from "../components/common/Backdrop";
import GameProviderDrawer from "../components/Game/GameProviderDrawer";
import TextCarousel from "../components/common/TextCarousel";
import Image from "../components/common/Image";
import SearchBar from "../components/common/SearchBar";
import { lighten } from "@material-ui/core";
import * as Constant from "../features/constant";
import Swal from "sweetalert2";
import LaunchDemo from "../components/common/LaunchDemo";

const pattern = /^((http|https|ftp):\/\/)/;

const Game_v2 = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector(selectCurrentToken);
  const { gameCategoryCode, gameProviderCode } = useParams();
  const [offset, setOffset] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [group, setGroup] = useState("ALL");
  const [currentProviderId, setCurrentProviderId] = useState("");
  const [appProviderName, setAppProviderName] = useState("");
  const [gameProviderDrawer, setGameProviderDrawer] = useState(false);
  const [appGameDisplay, setAppGameDisplay] = useState(false);
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const tabletView = useMediaQuery(theme.breakpoints.down("md"));
  const lang = localStorage.getItem("language");
  const [gameGroupDrawer, setGameGroupDrawer] = useState(false);
  const { playDemo, playDemoProvider, dialog } = LaunchDemo();
  const useSEO = process.env.REACT_APP_SEO === "TRUE";
  const categoryScrollRef = useRef(null);
  const ITEM_SCROLL = 66; // 58px item + 8px gap
  const scrollCategory = (dir) => categoryScrollRef.current?.scrollBy({ left: dir * ITEM_SCROLL, behavior: 'smooth' });

  const handleGameGroupDrawerToggle = (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setGameGroupDrawer(false);
  };

  const liveCasinoSeo = t("game.casinoseo.desc") !== "game.casinoseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.casinoseo.desc") }}></Typography>
    </>
  ) : null;

  const slotSeo = t("game.slotseo.desc") !== "game.slotseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.slotseo.desc") }}></Typography>
    </>
  ) : null;

  const sportbookSeo = t("game.sportbookseo.desc") !== "game.sportbookseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.sportbookseo.desc") }}></Typography>
    </>
  ) : null;

  const fishHunterSeo = t("game.fishingseo.desc") !== "game.fishingseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.fishingseo.desc") }}></Typography>
    </>
  ) : null;

  const cricketSeo = t("game.cricketseo.desc") !== "game.cricketseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.cricketseo.desc") }}></Typography>
    </>
  ) : null;

  const cardSeo = t("game.cardseo.desc") !== "game.cardseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.cardseo.desc") }}></Typography>
    </>
  ) : null;

  const esportSeo = t("game.esportseo.desc") !== "game.esportseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.esportseo.desc") }}></Typography>
    </>
  ) : null;

  const cockFightSeo = t("game.cockfightseo.desc") !== "game.cockfightseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.cockfightseo.desc") }}></Typography>
    </>
  ) : null;

  const crashSeo = t("game.crashseo.desc") !== "game.crashseo.desc" ? (
    <>
      <Typography mt={2} color="white" dangerouslySetInnerHTML={{ __html: t("game.crashseo.desc") }}></Typography>
    </>
  ) : null;

  const [searchInput, setSearchInput] = useState('');
  const handleSearchInputChange = event => {
    setSearchInput(event.target.value);
  };

  let gameCategory = gameCategoryCode;
  if (gameCategory) {
    gameCategory = gameCategory.replaceAll("-", "_");
  }
  const {
    data: allGameCategory,
    isFetching: isAllGameCategoryFetching,
    isLoading: isAllGameCategoryLoading,
  } = useGetGameCategoryQuery({ prefetch: true });

  const [customMenuItems, setCustomMenuItems] = useState([]);
  const [mobileMenuItems, setMobileMenuItems] = useState([]);

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const updateCategoryScroll = () => {
    const el = categoryScrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 1);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
  };

  useEffect(() => {
    const el = categoryScrollRef.current;
    if (!el) return;
    el.addEventListener('scroll', updateCategoryScroll);
    updateCategoryScroll();
    return () => el.removeEventListener('scroll', updateCategoryScroll);
  }, [mobileMenuItems]);

  useEffect(() => {
    setCustomMenuItems(Constant.getCustomMenuItems(allGameCategory?.result, t));
    const v2Items = [
      {
        name: 'Hot Game',
        code: 'HOT_GAME',
        image: `${process.env.REACT_APP_HEADER_LOGO}/HOT_GAME.png`,
        imageSelected: `${process.env.REACT_APP_HEADER_LOGO}/HOT_GAME.gif`,
      },
    ].concat(Constant.getCustomMenuItemsV2(allGameCategory?.result, t));
    setMobileMenuItems(v2Items);
  }, [allGameCategory]);

  useEffect(() => {
    if (!categoryScrollRef.current || !mobileMenuItems.length) return;
    const idx = mobileMenuItems.findIndex(item => item.code.toLowerCase() === gameCategory);
    if (idx < 0) return;
    const el = categoryScrollRef.current;
    const center = idx * ITEM_SCROLL - el.clientWidth / 2 + ITEM_SCROLL / 2;
    el.scrollLeft = Math.max(0, center);
  }, [gameCategory, mobileMenuItems]);

  const {
    data: gameProvider,
    isFetching: isGameProviderFetching,
    isLoading: isGameProviderLoading,
  } = useGetGameProviderQuery({ category: gameCategory }, { skip: gameCategory === 'hot_game', prefetch: true });

  const { data: homePage } = useGetHomePageQuery({ prefetch: true });

  const [
    getGameItem,
    {
      data: gameItem,
      isFetching: isGameItemFetching,
      isLoading: isGameItemLoading,
      isError: isGameItemError,
      isSuccess: isGameItemSuccess,
      error: gameItemError,
    },
  ] = useLazyGetGameItemQuery({ prefetch: true });

  const [
    getLaunchGame,
    {
      data: launchGame,
      isFetching: isLaunchGameFetching,
      isLoading: isLaunchGameLoading,
      isError: isLaunchGameError,
      isSuccess: isLaunchGameSuccess,
      error: launchGameError,
    },
  ] = useLazyGetLaunchGameQuery({ prefetch: true });

  const searchbarTextColor = process.env.REACT_APP_COLOR_SEARCHBAR_TEXT || "white";

  useEffect(() => {
    if (gameCategory === 'hot_game') return;
    setAppGameDisplay(false);
    getGameItem({
      category: gameCategory,
      offset: offset - 1,
      providerId: currentProviderId || "",
      keyword: searchQuery || "",
      group: group || "ALL",
    });
  }, [offset, currentProviderId, gameCategory, searchQuery, group]);

  useEffect(() => {
    setOffset(1);
  }, [currentProviderId]);

  useEffect(() => {
    setCurrentProviderId("");
    setSearchQuery("");
    setGroup("ALL");
    setOffset(1);
  }, [gameCategory]);

  useEffect(() => {
    if (searchQuery !== "") {
      setOffset(1);
    }
  }, [searchQuery]);

  useEffect(() => {
    if (location?.state?.providerId != null)
      setCurrentProviderId(location?.state?.providerId);
  }, [location?.state?.providerId]);

  useEffect(() => {
    if (!gameProvider) return;
    if (gameProviderCode !== undefined) {
      let selectedGameProvider = gameProvider?.result?.find((provider) => provider.name === gameProviderCode.replaceAll("-", " ").toUpperCase());
      if (selectedGameProvider) {
        setCurrentProviderId(selectedGameProvider.id);
      }
    }
    else {
      setCurrentProviderId(
        location?.state?.providerId || gameProvider?.result[0]?.id
      );
    }

    if (
      allGameCategory?.result?.find(
        (cat) => cat.code?.toLowerCase() === gameCategory
      )?.hasGameList &&
      gameProvider?.result[0]?.grouping
    ) {
      setGroup(gameProvider?.result[0]?.grouping[0]?.code || "");
    }
  }, [gameProvider, gameCategory]);

  useEffect(() => {
    if (!isLaunchGameLoading && !isLaunchGameFetching && isLaunchGameSuccess) {
      if (launchGame?.result?.gameType === "APP") {
        setAppGameDisplay(true);
      } else if (launchGame?.result?.gameType === "WEB") {
        if (launchGame?.result?.iframeSupported == true) {
          sessionStorage.setItem("prevPageBeforeGame", window.location.href);
          window.parent.location.href =
            Constant.getPath("/gameLauncher") +
            "?url=" +
            launchGame.result.gameUrl;
        }
        else {
          navigate(Constant.getPath("/gameRedirect") + "?url=" + launchGame.result.gameUrl);
        }
      }
    }
  }, [isLaunchGameLoading, isLaunchGameFetching, isLaunchGameSuccess]);

  useEffect(() => {
    if (isGameItemError) {
      Swal.fire({
        text: gameItemError?.data?.message,
        icon: "error"
      });
    }
  }, [isGameItemError]);

  useEffect(() => {
    if (isLaunchGameError) {
      Swal.fire({
        text: launchGameError?.data?.message,
        icon: "error"
      });
    }
  }, [isLaunchGameError]);

  const handlePageChange = (e, p) => {
    setOffset(p);
    window.scroll(0, 0);
  };

  const currentSeo =
    gameCategory === "live_casino"
      ? liveCasinoSeo
      : gameCategory === "slot"
        ? slotSeo
        : gameCategory === "sportbook"
          ? sportbookSeo
          : gameCategory === "fish_hunter"
            ? fishHunterSeo
            : gameCategory === "cricket"
              ? cricketSeo
              : gameCategory === "card"
                ? cardSeo
                : gameCategory === "esports"
                  ? esportSeo
                  : gameCategory === "cockfight"
                    ? cockFightSeo
                    : gameCategory === "crash"
                      ? crashSeo
                      : null;

  const primaryColor = theme.palette.primary.main;
  const secondaryColor = theme.palette.secondary.main;

  const selectedProvider = gameProvider?.result?.find(p => p.id === currentProviderId);
  const hasGameList = !!allGameCategory?.result?.find(cat => cat.code?.toLowerCase() === gameCategory)?.hasGameList;

  return (
    <Box
      sx={{
        backgroundColor: "theme.palette.background.home",
      }}
    >
      {dialog}
      {/* Banner Section */}
      <Box>
        {!mobileView && (
          <Image
            src={
              allGameCategory?.result?.find(
                (cat) => cat.code?.toLowerCase() === gameCategory
              )?.bannerUrl
            }
            alt={Constant.ALT_TAG_CATEGORY_BANNER + gameCategory}
          />
        )}
      </Box>

      {/* All, Hot & Other Categories with search bar — desktop only */}
      {!mobileView && allGameCategory?.result?.find(
        (cat) => cat.code?.toLowerCase() === gameCategory
      )?.hasGameList && (
          <Box
            sx={{
              width: "100%",
              backgroundColor: process.env.REACT_APP_COLOR_SEARCHBAR_BG || theme.palette.background.paper,
              pt: !mobileView ? 3 : 1,
              pb: !mobileView ? 1.2 : 0,
              px: !mobileView ? 1.2 : 0
            }}
          >
            <Container style={{ maxWidth: '3000px' }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: !mobileView ? "space-between" : "center",
                }}
              >
                <Box display="flex" sx={{
                  border: gameProvider?.result?.find((provider) => provider.id === currentProviderId)?.grouping ? `1px solid ${theme.palette.secondary.accent}` : "none",
                  py: "5px",
                  px: "10px",
                  borderRadius: "30px",
                  float: "left"
                }}>
                  {gameProvider?.result
                    ?.find((provider) => provider.id === currentProviderId)
                    ?.grouping?.map((grouping, index) => (
                      <Button
                        onClick={() => setGroup(grouping?.code)}
                        sx={{
                          "&:hover": {
                            background: "transparent",
                          },
                          mx: "10px"
                        }}
                        disableRipple
                      >
                        <Typography sx={{
                          color: (group === grouping?.code) ? theme.palette.secondary.accent : process.env.REACT_APP_COLOR_TEXT,
                          fontSize: "14px"
                        }}>
                          {t("gamegroup." + grouping?.code?.toLowerCase())}
                        </Typography>
                      </Button>
                    ))}
                </Box>
                <Box sx={{ float: "right" }}>
                  <TextField
                    sx={{
                      width: "180px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset.MuiOutlinedInput-notchedOutline": {
                          borderColor: searchbarTextColor,
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "9px 14px",
                          color: searchbarTextColor,
                          "&::placeholder": {
                            color: searchbarTextColor,
                            opacity: 0.7
                          }
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "30px 0 0 30px",
                        }
                      },
                      ".MuiOutlinedInput-notchedOutline": {
                        borderRadius: "30px 0 0 30px",
                      }
                    }}
                    placeholder={t("gamegroup.searchgame")}
                    value={searchInput}
                    onChange={(e) => {
                      setSearchInput(e.target.value);
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <Button sx={{
                    backgroundImage: `url(${process.env.REACT_APP_COLOR_SEARCHBAR_IMG || '/assets/img/red_small.png'})`,
                    backgroundSize: "100% 100%",
                    py: "10px",
                    px: "15px",
                    borderRadius: "0 30px 30px 0"
                  }}
                    onClick={() => setSearchQuery(searchInput)}
                  >
                    <Typography sx={{ fontSize: "14px" }}>
                      {t("gamegroup.searchall")}
                    </Typography>
                  </Button>
                </Box>
              </Box>
            </Container>
          </Box>
        )}

      {/* Game Provider Filter */}
      <Box
        pt={{ xs: 1, sm: 1, lg: 1, xl: 1 }}
        sx={{
          backgroundColor:
            location.pathname !== "/game/sportbook" &&
            location.pathname !== "/game/live-casino" &&
            process.env.REACT_APP_COLOR_SEARCHBAR_BG || theme.palette.background.paper,
        }}
      >
        {/* ── MOBILE CONTROLS ── */}
        {mobileView && (
          <Box pb={1} pt="53px">

            {/* 1. Horizontal icon category bar with fade + arrows */}
            {(() => {
              const fadeBg = process.env.REACT_APP_COLOR_SEARCHBAR_BG || theme.palette.background.paper;
              return (
                <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  {/* Left arrow + fade */}
                  {canScrollLeft && (
                    <Box
                      onClick={() => scrollCategory(-1)}
                      sx={{
                        position: 'absolute', left: 0, top: 0, bottom: 0, zIndex: 2,
                        display: 'flex', alignItems: 'center',
                        background: `linear-gradient(to right, ${fadeBg} 55%, transparent)`,
                        pr: 2, pl: 0.5, cursor: 'pointer', minWidth: 36,
                      }}
                    >
                      <ChevronLeft sx={{ fontSize: 24, color: process.env.REACT_APP_COLOR_PRIMARY || 'white', opacity: 0.85 }} />
                    </Box>
                  )}

                  {/* Scrollable strip */}
                  <Box ref={categoryScrollRef} sx={{
                    display: 'flex',
                    overflowX: 'auto',
                    gap: 1,
                    px: 3,
                    pb: 0.5,
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none',
                    flex: 1,
                  }}>
                    {mobileMenuItems.map((item, idx) => {
                      const isSelected = item.code.toLowerCase() === gameCategory || item.code === gameCategory.toUpperCase();
                      return (
                        <Box
                          key={idx}
                          onClick={() => {
                            navigate(Constant.getPath("/game/" + item.code.toLowerCase().replaceAll("_", "-")));
                          }}
                          sx={{
                            flex: '0 0 58px',
                            cursor: 'pointer',
                            borderRadius: '6px',
                            border: isSelected ? `2px solid ${secondaryColor}` : '2px solid transparent',
                            opacity: isSelected ? 1 : 0.65,
                            transition: 'opacity 0.2s, border-color 0.2s, background 0.2s',
                            background: isSelected
                              ? `linear-gradient(to bottom, ${lighten(secondaryColor, 0.25)}, ${secondaryColor})`
                              : 'transparent',
                            boxShadow: '1px 1px 0 rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.08)',
                          }}
                        >
                          <Box
                            component="img"
                            src={isSelected ? (item.imageSelected || item.image) : item.image}
                            alt={item.name}
                            sx={{ width: '100%', borderRadius: '4px', display: 'block' }}
                          />
                        </Box>
                      );
                    })}
                  </Box>

                  {/* Right arrow + fade */}
                  {canScrollRight && (
                    <Box
                      onClick={() => scrollCategory(1)}
                      sx={{
                        position: 'absolute', right: 0, top: 0, bottom: 0, zIndex: 2,
                        display: 'flex', alignItems: 'center',
                        background: `linear-gradient(to left, ${fadeBg} 55%, transparent)`,
                        pl: 2, pr: 0.5, cursor: 'pointer', minWidth: 36,
                      }}
                    >
                      <ChevronRight sx={{ fontSize: 24, color: process.env.REACT_APP_COLOR_PRIMARY || 'white', opacity: 0.85 }} />
                    </Box>
                  )}
                </Box>
              );
            })()}


            {/* 2. Provider dropdown (left) + Group dropdown (right) — only for hasGameList categories */}
            {hasGameList && gameProvider?.result?.length > 0 && (
              <Box sx={{ display: 'flex', gap: 1, px: 1, mt: 1, alignItems: 'center' }}>

                {/* Provider dropdown */}
                <FormControl size="small" sx={{ flex: 1 }}>
                    <Select
                      value={currentProviderId || ''}
                      onChange={(e) => {
                        const id = e.target.value;
                        setGroup("ALL");
                        setSearchQuery("");
                        setCurrentProviderId(id);
                        const provider = gameProvider.result.find(p => p.id === id);
                        if (provider) {
                          navigate(Constant.getPath("/game/" + gameCategory + "/" + provider.name.replaceAll(" ", "-").toLowerCase()));
                        }
                      }}
                      sx={{
                        fontSize: '13px',
                        color: process.env.REACT_APP_COLOR_TEXT || 'white',
                        '.MuiOutlinedInput-notchedOutline': { borderColor: process.env.REACT_APP_COLOR_HEADER_INPUTBORDER || '#cccccc' },
                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: process.env.REACT_APP_COLOR_HEADER_INPUTBORDER || '#cccccc' },
                        '.MuiSvgIcon-root': { color: process.env.REACT_APP_COLOR_PRIMARY || 'white' },
                      }}
                      MenuProps={{
                        sx: {
                          '& .MuiPaper-root': {
                            backgroundColor: process.env.REACT_APP_COLOR_SEARCHBAR_BG || '#1e1e1e',
                          },
                          '& .MuiMenuItem-root': {
                            fontSize: '13px',
                            color: process.env.REACT_APP_COLOR_TEXT || 'white',
                          },
                        },
                      }}
                    >
                      {gameProvider?.result?.map((p) => (
                        <MenuItem key={p.id} value={p.id} sx={{ color: process.env.REACT_APP_COLOR_TEXT || 'white', fontSize: '13px' }}>{p.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                {/* Group dropdown — only when selected provider has grouping */}
                {selectedProvider?.grouping && (
                  <FormControl size="small" sx={{ flex: 1 }}>
                    <Select
                      value={group}
                      onChange={(e) => setGroup(e.target.value)}
                      sx={{
                        fontSize: '13px',
                        color: process.env.REACT_APP_COLOR_TEXT || 'white',
                        '.MuiOutlinedInput-notchedOutline': { borderColor: process.env.REACT_APP_COLOR_HEADER_INPUTBORDER || '#cccccc' },
                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: process.env.REACT_APP_COLOR_HEADER_INPUTBORDER || '#cccccc' },
                        '.MuiSvgIcon-root': { color: process.env.REACT_APP_COLOR_PRIMARY || 'white' },
                      }}
                      MenuProps={{
                        sx: {
                          '& .MuiPaper-root': {
                            backgroundColor: process.env.REACT_APP_COLOR_SEARCHBAR_BG || '#1e1e1e',
                          },
                          '& .MuiMenuItem-root': {
                            fontSize: '13px',
                            color: process.env.REACT_APP_COLOR_TEXT || 'white',
                          },
                        },
                      }}
                    >
                      {selectedProvider.grouping.map((g) => (
                        <MenuItem key={g.code} value={g.code} sx={{ color: process.env.REACT_APP_COLOR_TEXT || 'white', fontSize: '13px' }}>
                          {t("gamegroup." + g.code.toLowerCase())}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            )}

            {/* 3. Search bar with icon — below dropdowns */}
            <Box sx={{
              px: 1,
              mt: 1,
              display: 'flex',
              alignItems: 'center',
              background: process.env.REACT_APP_COLOR_SEARCHBAR_BG || 'rgba(255,255,255,0.1)',
              borderRadius: '8px',
              mx: 1,
              height: 34,
              border: `1px solid ${process.env.REACT_APP_COLOR_HEADER_INPUTBORDER || '#cccccc'}`,
            }}>
              <SearchIcon sx={{ color: process.env.REACT_APP_COLOR_PRIMARY || 'white', fontSize: 18, mx: 0.5, flexShrink: 0 }} />
              <Box
                component="input"
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder={t("gamegroup.searchgame")}
                sx={{
                  background: 'transparent',
                  border: 'none',
                  outline: 'none',
                  color: process.env.REACT_APP_COLOR_TEXT || 'white',
                  fontSize: '13px',
                  flex: 1,
                  padding: '0 4px',
                  '&::placeholder': { color: `${process.env.REACT_APP_COLOR_TEXT || '#ffffff'}99` },
                }}
              />
            </Box>

          </Box>
        )}

        <Container style={{ maxWidth: '3000px' }}>
          {mobileView ? (
            null
          ) : (
            <>
              {allGameCategory?.result?.find(
                (cat) => cat.code?.toLowerCase() === gameCategory
              )?.hasGameList && (
                  <>
                    <Grid container spacing={2}>
                      {gameProvider?.result?.map((provider, index) => (
                        <Grid key={index} item sx={{ width: "65px", textAlign: "center" }}>
                          <Box
                            sx={{
                              border: 1,
                              display: "flex",
                              justifyContent: "center",
                              height: "50px",
                              width: "50px",
                              alignItems: "center",
                              boxSizing: "border-box",
                              wordWrap: "break-word",
                              cursor: "pointer",
                              borderRadius: "50%",
                              borderColor:
                                currentProviderId === provider.id
                                  ? theme.palette.primary.main
                                  : darken(theme.palette.background.paper, 0.2),
                              overflow: "hidden",
                              margin: "0 auto",
                              backgroundColor: currentProviderId === provider.id
                                ? theme.palette.primary.main
                                : "#313338",
                            }}
                            onClick={() => {
                              setSearchInput("");
                              setSearchQuery("");
                              setCurrentProviderId(provider.id);
                              setGroup("ALL");
                              navigate(Constant.getPath("/game/" + gameCategory + "/" + provider.name.replaceAll(" ", "-").toLowerCase()));
                            }}
                          >
                            <img
                              src={
                                currentProviderId === provider.id
                                  ? provider.logoSelectedUrl
                                  : provider.logoUrl
                              }
                              alt={Constant.ALT_TAG_GENERAL_PROVIDER + provider.name}
                            />
                          </Box>
                          <Typography
                            color={currentProviderId === provider.id ? theme.palette.tertiary.main : process.env.REACT_APP_COLOR_TEXT || "white"}
                            fontSize="12px"
                            pt="8px"
                          >
                            {provider.name.split(" ")[0].length > 6
                              ? provider.name.split(" ")[0].slice(0, 6) + "..."
                              : provider.name.split(" ")[0]}
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </>
                )}
            </>
          )}
        </Container>
      </Box>
      <Container style={{ maxWidth: '3000px' }}>
        {/* Mobile View Filter Drawer */}
        <GameProviderDrawer
          gameProviderDrawer={gameProviderDrawer}
          setGameProviderDrawer={setGameProviderDrawer}
          gameProvider={gameProvider?.result}
          currentProviderId={currentProviderId}
          setOffset={setOffset}
          setCurrentProviderId={setCurrentProviderId}
          gameCategory={gameCategory}
        />
        {/* App Game PopUp */}
        {(isLaunchGameLoading || isLaunchGameFetching) && <Backdrop />}
        {!isLaunchGameLoading &&
          !isLaunchGameFetching &&
          isLaunchGameSuccess && (
            <>
              {appGameDisplay && (
                <>
                  <Box display="flex" flexDirection="column" pt={2}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-start"
                      alignSelf="center"
                      pt={2}
                    >
                      <Image src={launchGame?.result?.bannerUrl} />
                      <Typography color={theme.palette.primary.main} pt={2}>
                        {`EASY STEP BY STEP TO PLAY ${appProviderName} ON YOUR MOBILE`}
                      </Typography>
                      <Typography color={theme.palette.primary.main} pt={2}>
                        Step 1
                      </Typography>
                      <Typography color={process.env.REACT_APP_COLOR_APPGAME_TEXT || "black"}>
                        {`Transfer fund into ${appProviderName} wallet to get your login ID and password on the below section of this page.`}
                      </Typography>
                      <Typography color={theme.palette.primary.main} pt={2}>
                        Step 2
                      </Typography>
                      <Typography color={process.env.REACT_APP_COLOR_APPGAME_TEXT || "black"}>
                        {`Download ${appProviderName} from the download link below.`}
                      </Typography>
                      <Typography color={theme.palette.primary.main} pt={2}>
                        Step 3
                      </Typography>
                      <Typography color={process.env.REACT_APP_COLOR_APPGAME_TEXT || "black"} pb={3}>
                        {`Launch the apps in your mobile and login with the ID and password from below.`}
                      </Typography>
                      <Divider />
                      <FormControl
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          pt: 4,
                          "& .MuiTextField-root": {
                            pb: 3,
                          },
                        }}
                      >
                        <TextField
                          label="Username"
                          value={launchGame?.result?.mobileAppUsername}
                          InputLabelProps={{ shrink: true }}
                          disabled
                          type="text"
                          size="small"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  disableRipple
                                  sx={{
                                    "&.MuiButtonBase-root:hover": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                >
                                  <CopiedTooltip
                                    text={launchGame?.result?.mobileAppUsername}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                        <TextField
                          label="Password"
                          value={launchGame?.result?.mobileAppPassword}
                          InputLabelProps={{ shrink: true }}
                          disabled
                          type="text"
                          size="small"
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  disableRipple
                                  sx={{
                                    "&.MuiButtonBase-root:hover": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                >
                                  <CopiedTooltip
                                    text={launchGame?.result?.mobileAppPassword}
                                  />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </FormControl>
                    </Box>
                    <Box display="flex" alignSelf="center">
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: theme.palette.button.primary.main,
                        }}
                        onClick={() => {
                          let url = launchGame.result.mobileAppUrlIos[0];
                          if (
                            !pattern.test(launchGame.result.mobileAppUrlIos[0])
                          ) {
                            url = "https://" + url;
                          }
                          window.open(url, "_blank");
                        }}
                      >
                        IOS
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          backgroundColor: theme.palette.button.primary.main,
                          ml: 2,
                        }}
                        onClick={() => {
                          let url = launchGame.result.mobileAppUrlAndroid[0];
                          if (
                            !pattern.test(
                              launchGame.result.mobileAppUrlAndroid[0]
                            )
                          ) {
                            url = "https://" + url;
                          }
                          window.open(url, "_blank");
                        }}
                      >
                        ANDROID
                      </Button>
                    </Box>
                  </Box>
                </>
              )}
            </>
          )}
        {/* Hot Game grid — recommendGame from home API */}
        {gameCategory === 'hot_game' && (
          <Box pb={5} mb={4}>
            <Grid
              container
              justifyContent="center"
              mt={mobileView ? 0 : 1}
              width={{ xs: "100%", sm: "90%" }}
              margin={{ xs: "0 auto", sm: "0 auto" }}
            >
              {(homePage?.result?.recommendGame || [])
                .filter(g => !searchQuery || g.name.toLowerCase().includes(searchQuery.toLowerCase()))
                .map((game, index) => (
                  <Grid item xs={3} sm={2} md={1.5} key={index} display="flex" justifyContent="center" sx={{ padding: "3px" }}>
                    <GameCard
                      imageUrl={game?.thumbnailUrl}
                      imageWidth={mobileView ? "80px" : tabletView ? "100px" : "150px"}
                      imageHeight={mobileView ? "80px" : tabletView ? "120px" : "150px"}
                      title={game.name}
                      alt={Constant.ALT_TAG_GENERAL_GAME + game.name}
                      onClick={() => {
                        if (!token) {
                          if (game?.demoSupported) {
                            playDemo(game);
                          } else {
                            navigate({ pathname: location.pathname, search: "?login=1" });
                          }
                        } else {
                          getLaunchGame({ id: game?.id, type: game?.gameType, category: game.categoryCode, isMobile: mobileView });
                        }
                      }}
                    />
                  </Grid>
                ))}
            </Grid>
          </Box>
        )}

        {/* Game Item List */}
        <Box pb={5} mb={4} mt={mobileView ? 0 : 3}>
          {!isGameItemLoading &&
            !isGameItemFetching &&
            isGameItemSuccess &&
            !!allGameCategory?.result &&
            allGameCategory.result.find(
              (cat) => cat.code?.toLowerCase() === gameCategory
            )?.hasGameList && (
              <>
                <Grid
                  container
                  justifyContent="center"
                  mt={mobileView ? 0 : 1}
                  width={{ xs: "100%", sm: "90%" }}
                  margin={{ xs: "0 auto", sm: "0 auto" }}
                >
                  {gameItem?.result?.data?.map((game, index) => (
                    <>
                      {!appGameDisplay && (
                        <Grid
                          item
                          spacing={2}
                          xs={3}
                          sm={2}
                          md={1.5}
                          key={index}
                          display="flex"
                          justifyContent="center"
                          sx={{ padding: "3px", mb: 1 }}
                        >
                          <GameCard
                            imageUrl={game?.thumbnailUrl}
                            imageWidth={
                              mobileView
                                ? "80px"
                                : tabletView
                                  ? "100px"
                                  : "150px"
                            }
                            imageHeight={
                              mobileView
                                ? "80px"
                                : tabletView
                                  ? "120px"
                                  : "150px"
                            }
                            alt={Constant.ALT_TAG_GENERAL_GAME + game.name}
                            onClick={() => {
                              if (!token) {
                                if (game?.demoSupported) {
                                  playDemo(game);
                                } else {
                                  navigate({
                                    pathname: location.pathname,
                                    search: "?login=1",
                                  });
                                }
                              } else {
                                setAppProviderName(
                                  gameProvider?.result?.find(
                                    (provider) =>
                                      provider?.id === game?.providerId
                                  )?.name
                                );
                                getLaunchGame({
                                  id: game?.id,
                                  type: game?.gameType,
                                  isMobile: mobileView
                                });
                              }
                            }}
                            title={game?.name}
                            subtitle={
                              gameProvider?.result?.find(
                                (provider) => provider?.id === game?.providerId
                              )?.name
                            }
                            description={{}}
                          />
                        </Grid>
                      )}
                    </>
                  ))}
                </Grid>
                {gameItem?.result?.totalPage !== 0 && !appGameDisplay && (
                  <Stack
                    mt={tabletView ? 1 : 2}
                    spacing={2}
                    size="small"
                    alignItems="center"
                  >
                    <Pagination
                      onChange={handlePageChange}
                      count={gameItem?.result?.totalPage}
                      shape="rounded"
                      page={offset}
                      sx={{
                        "& .MuiPaginationItem-root": {
                          color: process.env.REACT_APP_COLOR_PAGINATION_NUMBER2 || "white",
                          "&.Mui-selected": {
                            background: lighten(
                              process.env.REACT_APP_COLOR_PAGINATION || theme.palette.background.paper,
                              0.02
                            ),
                            color: process.env.REACT_APP_COLOR_PAGINATION_NUMBER1 || "white",
                          },
                        },
                        "& .MuiPaginationItem-icon": {
                          color: process.env.REACT_APP_COLOR_PAGINATION_NUMBER2 || "white",
                        },
                      }}
                    />
                  </Stack>
                )}
              </>
            )}
          {gameCategory !== 'hot_game' && !!allGameCategory?.result && !allGameCategory.result.find(
            (cat) => cat.code?.toLowerCase() === gameCategory
          )?.hasGameList && (
              <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                {gameProvider?.result?.filter(p => !searchQuery || p.name.toLowerCase().includes(searchQuery.toLowerCase())).map((provider, index) => (
                  <Grid
                    item
                    xs={6}
                    sm={3}
                    md={2}
                    key={index}
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      sx={{ cursor: "pointer" }}
                      onClick={() => {
                        if (!token) {
                          if (provider.demoSupported) {
                            playDemoProvider(provider, gameCategory);
                          } else {
                            navigate({
                              pathname: location.pathname,
                              search: "?login=1",
                            });
                          }
                        } else {
                          setAppProviderName(provider?.name);
                          getLaunchGame({
                            id: provider?.id,
                            type: provider?.gameType,
                            category: gameCategory,
                            isMobile: mobileView
                          });
                        }
                      }}
                    >
                      <Box overflow="hidden">
                        <Image hovered={true} src={provider.providerImgUrl} sx={{ borderRadius: 4 }} alt={Constant.ALT_TAG_GENERAL_PROVIDER + provider.name} />
                      </Box>
                      <Typography
                        color={theme.palette.primary.main}
                        fontSize={13}
                        fontWeight={800}
                        mt={1}
                      >
                        {provider.name}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            )}
        </Box>
        {!mobileView && currentSeo && !useSEO && (
          <Container>
            <Box pt={{ xs: 4, sm: 4, md: 4 }} pb={{ xs: 11, sm: 5, md: 5 }}>
              <TextCarousel
                html={[currentSeo]}
                slidesPerView={1}
                pagination={true}
                spaceBetween={0}
              />
            </Box>
          </Container>
        )}
      </Container>
    </Box>
  );
};

export default Game_v2;
